export const baseURL = "https://portalapi.lucky4.co.mz/";
// 
// export const baseURL = "http://0.0.0.0:3323/"
// Warning std versions prefixed with 'v' will be deprecated on October 1st 2020. Please change your import to  (at https://deno.land/std@v0.63.0/fmt/colors.ts)